import React, { useState, useEffect, useRef } from "react";
import { IconFeatherSearch } from "@/Icons/img";
import ReactInputMask from "react-input-mask";
import { api } from "@/services/api";
import ModalPopup from "@/components/ModalPopup";
import ShimmerEffect from "@/components/Shimmer";

import {
	Container,
	PlacesList,
	ShimmerEffect as Shimmer,
	ContainerButtons,
} from "./styles";

export default function Stores({ digitalStores }) {
	const mapCanvas = useRef(null);
	const [loadApiGoogle, setLoadApiGoole] = useState(false);

	const [storeType, setStoreType] = useState(1);
	const [findStoreType, setFindStoreType] = useState(1);
	const [cep, setCep] = useState("");
	const [city, setCity] = useState("");
	const [address, setAddress] = useState("");

	const [places, setPlaces] = useState([]);

	const [loadData, setLoadData] = useState(false);

	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});

	const loadElements = [];

	for (let index = 0; index < 4; index++) {
		loadElements.push(index);
	}

	// carregando blibioteca do google maps
	useEffect(() => {
		const script = document.createElement("script");

		script.src = `https://maps.googleapis.com/maps/api/js?sensor=false&key=${process.env.REACT_APP_GOOGLE_KEY}`;
		script.async = true;

		document?.body?.appendChild(script);
		script?.addEventListener("load", () => {
			setLoadApiGoole(true);
		});

		return () => {
			document?.body?.removeChild(script);
			document?.head?.querySelectorAll("script").forEach((el, index) => {
				let scriptSource = el?.getAttribute("src");
				if (scriptSource?.match(/maps.googleapis/g)) {
					el?.remove();
				}
			});
		};
	}, []);

	// carregando mapa
	useEffect(() => {
		if (mapCanvas && loadApiGoogle && places) {
			renderPoints(places);
		}
	}, [mapCanvas, loadApiGoogle, places]);

	// ao cep estar completo
	// useEffect(() => {
	// 	const value = cep;
	// 	const valueCharacters = value.replace(/[-_.]/g, "").length;
	// 	if (valueCharacters === 8) {
	// 		handleGetStores({ cep });
	// 	}
	// }, [cep]);

	function handleSearchType(data) {
		if (data === cep) {
			const value = data;
			const valueCharacters = value.replace(/[-_.]/g, "").length;
			if (valueCharacters === 8) {
				handleGetStores(data);
			}
		} else {
			handleGetStores(data);
		}
	}

	// pegando lista de lojas
	function handleGetStores(data) {
		setLoadData(true);

		api.get("merchant/list/stores", {
			params: data,
		})
			.then((res) => {
				if (res.data.status === 500) {
					setModalPopup(true);
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
				}

				if ( res.data.status === 404 ) {
					setModalPopup(true);
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
				}

				if (res.data.status === 200) {
					setPlaces(res.data.list);
				}
			})
			.catch((error) => {
				console.error({ endPoint: "merchant/list/stores", error });
			})
			.finally(() => {
				setLoadData(false);
			});
	}

	// funcao para redenrizar pontos
	function renderPoints(locations, defaultZoom = true) {
		if (locations.length > 0) {
			const google = window.google;
			const map = new google.maps.Map(mapCanvas.current, {
				zoom: defaultZoom ? 6 : 10,
				center: {
					lat: parseFloat(locations[0].localization.lat),
					lng: parseFloat(locations[0].localization.lng),
				},
			});

			locations.forEach((e) => {
				const marker = new google.maps.Marker({
					position: {
						lat: parseFloat(e.localization.lat),
						lng: parseFloat(e.localization.lng),
					},
					map,
					title: e.infoTitle,
					icon: `${
						require("@/assets/img/Icon-feather-map-pin.svg").default
					}`,
				});

				const infowindow = new google.maps.InfoWindow({
					content: `<div id="content"> 
                            <div id="bodyContent"> 
                                <p style="font-family: "Montserrat", sans-serif;">
                                    <strong class="h6">${e.store}</strong>
                                </p>
								<p>${e.localization.address} ${e.localization.number}, 
								${e.localization.district !== null ? (e.localization.district + " - ") : "" } ${e.localization.city}
								</p>
                                <p>Telefone: ${e.phone}</p>
                            </div> 
                        </div>`,
					maxWidth: 300,
				});

				if (!defaultZoom) {
					infowindow.open(map, marker);
				} else {
					marker.addListener("click", () => {
						infowindow.open(map, marker);
					});
				}
			});
		}
	}

	// funcao para pegar local do usaurio
	function geoLocation() {
		if ("geolocation" in navigator) {
			navigator.geolocation.getCurrentPosition(
				(data) => {
					handleGetStores({
						lat: data.coords.latitude,
						lng: data.coords.longitude,
					});
				},
				(error) => {
					console.log(error);
				},
			);
		} else {
			setModalPopup(true);
			setModalContent({
				title: "Programa Fidelidade GERIOOX",
				content:
					"Sinto muito, mas os serviços de geolocalização não são compatíveis com seu navegador.",
			});
		}
	}

	function handleZoomPoit(index) {
		renderPoints([places[index]], false);
	}

	return (
		<div className='row'>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(!modalPopup)}
			/>
			<div className='col-12 col-lg-4'>
				<ContainerButtons>
					<div className='btns-group'>
						<button
							className={
								storeType === 1
									? "btn-stores active "
									: "btn-stores"
							}
							onClick={() => setStoreType(1)}>
							Lojas físicas
						</button>
						<button
							className={
								storeType === 2
									? "btn-stores active "
									: "btn-stores"
							}
							onClick={() => setStoreType(2)}>
							Lojas online
						</button>
					</div>
				</ContainerButtons>
				<div
					style={{
						display: storeType === 1 ? "block" : "none",
					}}>
				<ContainerButtons>
				<div className='btns-group findstore'>
						<button
							className={
								findStoreType === 1
									? "btn-stores active "
									: "btn-stores"
							}
							onClick={() => setFindStoreType(1)}>
							CEP
						</button>
						<button
							className={
								findStoreType === 2
									? "btn-stores active "
									: "btn-stores"
							}
							onClick={() => setFindStoreType(2)}>
							Cidade
						</button>
						<button
							className={
								findStoreType === 3
									? "btn-stores active "
									: "btn-stores"
							}
							onClick={() => setFindStoreType(3)}>
							Endereço
						</button>
					</div>
				</ContainerButtons>
				<div style={{ display: findStoreType === 1 ? "block" : "none" }}>
					<p className='text-content'>
						Digite seu CEP no espaço abaixo para encontrar a loja
						participante mais próxima de você.
					</p>

					<div className='search-zip'>
						<label>
							<ReactInputMask
								mask='99999-999'
								type='text'
								placeholder='00000-000'
								value={cep}
								onChange={(e) => setCep(e.target.value)}
							/>
							<span
								value={cep}
								onClick={() => handleSearchType({cep})}
								style={{ cursor: "pointer" }}
							>
								<IconFeatherSearch />
							</span>
						</label>

						<a
							href='//www.buscacep.correios.com.br/sistemas/buscacep/'
							target='_blank'
							rel='noopener noreferrer'>
							Não sei o CEP
						</a>
					</div>
				</div>
				<div style={{ display: findStoreType === 2 ? "block" : "none" }}>
					<p className='text-content'>
						Digite sua cidade no espaço abaixo para encontrar a loja
						participante mais próxima de você.
					</p>

					<div className='search-zip'>
						<label>
							<ReactInputMask
								mask=''
								type='text'
								placeholder='São Paulo'
								value={city}
								onChange={(e) => setCity(e.target.value)}
							/>
							<span
								value={city}
								onClick={() => handleSearchType({city})}
								style={{ cursor: "pointer" }}
							>
								<IconFeatherSearch />
							</span>
						</label>
					</div>
				</div>
				<div style={{ display: findStoreType === 3 ? "block" : "none" }}>
					<p className='text-content'>
						Digite seu endereço no espaço abaixo para encontrar a loja
						participante mais próxima de você.
					</p>

					<div className='search-zip'>
						<label>
							<ReactInputMask
								mask=''
								type='text'
								placeholder='Rua Alfredo Pujol, 379'
								value={address}
								onChange={(e) => setAddress(e.target.value)}
							/>
							<span
								value={address}
								onClick={() => handleSearchType({address})}
								style={{ cursor: "pointer" }}
							>
								<IconFeatherSearch />
							</span>
						</label>
					</div>
				</div>
					<div
						style={{ display: storeType === 1 ? "block" : "none" }}>
						{places && places.length > 0 && (
							<p className='search-result'>
								Exibindo {places.length} lojas próximas nessa
								área.
							</p>
						)}
						<PlacesList className='placeList'>
							{places?.map((local, index) => (
								<li
									key={index}
									data-index={index}
									data-target={`place-${index}`}
									onClick={() => handleZoomPoit(index)}>
									<p>{local.store}</p>
									<p>
										{local.localization.address},{" "}
										{local.localization.number}
										{local.localization.district && (" - " + local.localization.district)},{" "}
										{local.localization.city} - CEP{" "}
										{local.localization.zip_code}
									</p>
									<p>Tel: {local.phone}</p>
								</li>
							))}
						</PlacesList>
					</div>
				</div>
				<div
					style={{
						display: storeType === 2 ? "block" : "none",
					}}>
					<p className='text-content'>Atendimento para todo brasil</p>
				</div>
			</div>

			<div className='col-12 col-lg-8 pl-lg-5'>
				<div
					style={{
						display: storeType === 1 ? "block" : "none",
						height: "500px",
					}}
					className='map'>
					{loadData === false && places.length === 0 && (
						<Container>
							<img
								loading='lazy'
								src={
									require("@/assets/img/mapCapa.jpg").default
								}
								alt='map'
							/>
							<button onClick={() => geoLocation()}>
								Usar minha localizacao
							</button>
						</Container>
					)}
					{loadData === true && places.length === 0 && <Shimmer />}
					{places.length > 0 && (
						<div
							ref={mapCanvas}
							id='map-canvas'
							style={{ height: "100%", width: "100%" }}></div>
					)}
				</div>

				<div
					style={{ display: storeType === 2 ? "block" : "none" }}
					className='row'>
					<div className='col-12'>
						<div className='row row-cols-1 row-cols-lg-2 stores'>
							{digitalStores
								? digitalStores.map((store, index) => (
										<div key={index} className='col store'>
											<img
												loading='lazy'
												className='store__image'
												src={`${process.env.REACT_APP_URL_STORE}/${store.photo}`}
												alt={store.store}
											/>
											<div className='store-content'>
												<h3 className='store-content__title'>
													{store.store}
												</h3>
												<a
													className='store-content__link'
													href={store.website}
													target='_blank'
													rel='noopener noreferrer'>
													comprar
												</a>
											</div>
										</div>
								  ))
								: loadElements.map((_, index) => (
										<div key={index} className='col store'>
											<ShimmerEffect
												width={80}
												height={80}
												border={0}
											/>
											<div className='store-content'>
												<ShimmerEffect
													width={80}
													height={21}
												/>
												<ShimmerEffect
													width={130}
													height={38}
												/>
											</div>
										</div>
								  ))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}